class UserSearchInlineButtonListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('click', context.selector, function (){

            let selectors = new UserSearchInlineSelectors();

            let panel = $(this).closest('.panel');
            let input = panel.find(selectors.getUserSearchInlineInputSelector());

            let results_div = panel.find(selectors.getUserSearchInlineResultsSelector());

            makeRequest(
                "POST",
                laroute.route('users.search'),
                {term: input.val()}
            ).then(function (data){
                if(ExceptionsHelper.interface.validateResult(data))
                {




                    results_div.empty().append(data.view);

                    if(data.result.length > 0)
                        panel.find('.user_input').addClass('hide');
                    else
                        panel.find('.user_input').removeClass('hide');
                }
            });

        });



    }

}